import angular from 'angular';
import uiRouter from 'angular-ui-router';
import goldupgradeComponent from './goldupgrade.component';

let goldupgradeModule = angular.module('goldupgrade', [
    uiRouter
])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.goldupgrade', {
                url: '/golpupgrade',
                resolve: {
                    data: function ($stateParams, $window, myBookingService, authService, $state) {
                        'ngInject'

                        let GOLDUPGRADE_STATUS_OK = 'ok';

                        return myBookingService.postGoldProtectionUpgrade($stateParams.bookingReference).then(booking => {
                            if (booking.status == GOLDUPGRADE_STATUS_OK) {
                                $window.location = booking.payment_url;
                            }
                            else {
                                return booking.status;
                            }
                        }, function (error) {
                            if (error.status === 401) {
                                authService.clearSession();
                                $state.go('auth.login');
                            }
                            return null;
                        });
                    }
                },
                views: {
                    'booking@bookings.booking': {
                        template: '<goldupgrade status="$resolve.data"></goldupgrade>'
                    }
                }
            })
    })
    .component('goldupgrade', goldupgradeComponent)
    .name;

export default goldupgradeModule;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/goldupgrade/goldupgrade.js